export const API_URL = process.env.REACT_APP_API_URL;
export const WORKFLOW_API_URL = process.env.REACT_APP_WORKFLOW_ENGINE_API_URL;
export const PO_URL = process.env.REACT_APP_PO_URL;
export const ACCESS_TOKEN_KEY = 'x-access-auth';
export const REFRESH_TOKEN_KEY = 'x-refresh-auth';
